import { render, staticRenderFns } from "./SequenceDiagramContainer.vue?vue&type=template&id=2282deae&"
import script from "./SequenceDiagramContainer.vue?vue&type=script&lang=ts&"
export * from "./SequenceDiagramContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports